import { useQuery } from '@tanstack/react-query';
import React from 'react';

import { ObjectCard } from '@column/column-ui-kit';

import { ROUTE } from '~/app/routes';
import { useNavigate } from '~/lib/navigation';
import { CardAccount, CardAccountRepository } from '~/repositories/CardAccountRepository';
import { useSessionStore } from '~/stores/Session';

interface CardAccountCardProps {
  cardAccountId: string;
}

const getCardAccountName = (cardAccount?: CardAccount) => {
  if (!cardAccount) return undefined;
  return `Card Account ${cardAccount.id}`;
};

export const CardAccountCard: React.FC<CardAccountCardProps> = ({ cardAccountId }) => {
  const navigate = useNavigate();
  const { currentPlatform } = useSessionStore();

  const {
    data: cardAccount,
    isLoading,
    error,
  } = useQuery<CardAccount>({
    queryKey: [currentPlatform?.id, 'card-account', cardAccountId],
    queryFn: async () => CardAccountRepository.get(cardAccountId),
    enabled: !!cardAccountId,
    gcTime: 30000,
    staleTime: 10000,
  });

  const handleNavigate = () => {
    navigate(`${ROUTE.CARD_ACCOUNTS}/edit/${cardAccountId}`);
  };

  return (
    <ObjectCard
      error={error ? 'Failed to load card account' : undefined}
      isLoading={isLoading}
      primaryText={getCardAccountName(cardAccount) || 'Card Account'}
      id={{ label: 'ID:', value: cardAccountId }}
      onClick={handleNavigate}
    />
  );
};
